export const buildSelectionMap = (items = []) => {
  const initial = {};
  items.forEach((item) => {
    if (item.checked) initial[item.id] = true;
  });
  return initial;
};

export const selectedIdsFromMap = (map = {}) =>
  Object.entries(map)
    .filter(([, value]) => value)
    .map(([key]) => key);

export const toggleSelection = (selection, id) => ({
  ...selection,
  [id]: !selection[id],
});

export const setSelectionForIds = (selection, ids, selected) => {
  const next = { ...selection };
  ids.forEach(id => { next[id] = selected; });
  return next;
};

export const toggleSelectedId = (selectedIds, id) =>
  selectedIds.includes(id)
    ? selectedIds.filter(selectedId => selectedId !== id)
    : [...selectedIds, id];
